import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const AlarmSystemService = {
    getEventsType: async () => axios.get(API_URL + `/contactEvent/getEventsType`).then(({data}) => data.map(d => ({value: d.id, label: d.text}))).catch((err) => { throw err })
}

export default AlarmSystemService;